<div [formGroup]="frmNewContractStartMonth">
  <mat-form-field>
    <mat-label>New Contract Start Month</mat-label>
    <input
    matInput
    [matDatepicker]="dp"
    formControlName="newContractStartMonth"
    [min]="minDate"
    [max]="maxDate"
    (dateChange)="onChange($event)"
    id="newContractStartMonth"
    />
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp
                    color="accent"
                    startView="multi-year"
                    (monthSelected)="chosenMonthHandler($event, dp)">
    </mat-datepicker>
    <mat-error style="font-size: 12px" *ngIf="(frmNewContractStartMonth.touched || frmNewContractStartMonth.dirty) && frmNewContractStartMonth.get('newContractStartMonth').errors">Please select a contract start month</mat-error>

  </mat-form-field>
</div>
